import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "menu-panel" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "user-avatar flex justify-center" }
const _hoisted_5 = {
  key: 1,
  class: "avatar-img flex justify-center"
}
const _hoisted_6 = { class: "username" }
const _hoisted_7 = { class: "flex justify-center flex-1" }
const _hoisted_8 = { class: "balance-value" }
const _hoisted_9 = { class: "popup-content" }
const _hoisted_10 = { class: "menu-btn-bar flex justify-between" }
const _hoisted_11 = { class: "action-btn-text" }
const _hoisted_12 = { class: "action-btn-text" }
const _hoisted_13 = { class: "action-btn-text" }
const _hoisted_14 = { class: "menu-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "badge-wrap"
}
const _hoisted_17 = {
  key: 1,
  class: "badge-wrap"
}
const _hoisted_18 = {
  key: 2,
  class: "badge-wrap"
}
const _hoisted_19 = { class: "menu-name" }
const _hoisted_20 = { class: "popup-footer" }
const _hoisted_21 = { class: "w-full flex justify-between" }
const _hoisted_22 = { class: "follow-wrap flex-1" }
const _hoisted_23 = { class: "follow-title" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "flex justify-center" }

import { ref, reactive, inject } from 'vue';
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia';
import { useHelpTool } from '@/hooks';
import { useUserStore, useAccountStore, useGameStore, useReddotStore, useSettingsStore } from "@/store";
import packageJson from '/package.json';


export default {
  __name: 'MenuPanel',
  props: ['show'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {



const emit = __emit

const MyDialog = inject('myDialog');

const { t } = useI18n()
const router = useRouter()
const { openBrowser } = useHelpTool()

const userStore = useUserStore();
const accountStore = useAccountStore();
const redDotStore = useReddotStore();
const { loginBonusRewardNum, inboxUnread, taskRewardNum } = storeToRefs(redDotStore);
const settingsStore = useSettingsStore()
const { downloadUrl, showAppDownload, version, followUs } = storeToRefs(settingsStore);
const h5Version = ref(packageJson.version);

const menuList = reactive([
  // { code: 'profile',  pathName: 'profile' },
  { code: 'gameRecords',  pathName: 'gameRecord' },
  { code: 'records',  pathName: 'records' },
  // { code: 'chat',  pathName: 'livechat' },
  { code: 'vip',  pathName: 'vip' },
  { code: 'events',  pathName: 'event' },
  { code: 'inbox',  pathName: 'inbox' },
  // { code: 'security',  pathName: 'securityCenter' },
  // { code: 'settings',  pathName: 'setting' },
  { code: 'redeem',  pathName: 'redeem' },
]);

const showBalance = ref(true);
const clickMenu = item => {
  if(item.onClick) {
    item.onClick()
  } else {
    router.push({ name: item.pathName })
  }
}

const doLogout = () => {
  MyDialog.confirm({
    message: t('msg.logout'),
  })
  .then(() => {// on confirm
    userStore.logout();
  })
  .catch(() => {});
}

const reloadApp = () => {
  location.href = `${location.origin}?t=${new Date().getTime()}`
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: __props.show,
      position: "left",
      "close-on-click-overlay": false,
      onClickOverlay: _cache[10] || (_cache[10] = $event => (emit('onClose')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(userStore).avatar)
                ? (_openBlock(), _createBlock(_component_van_image, {
                    key: 0,
                    class: "avatar-img",
                    fit: "cover",
                    src: _unref(userStore).avatar
                  }, null, 8, ["src"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_van_icon, { name: "contact" })
                  ]))
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(userStore).username), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_van_image, {
                class: "coin-icon",
                src: require('@/assets/img/common/coin.png')
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(showBalance.value ? _ctx.$filter.outputAmount(_unref(accountStore).balance, 2) : '-'), 1),
              _withDirectives(_createVNode(_component_van_image, {
                class: "action-icon",
                src: require('@/assets/img/common/menu/eye.png'),
                onClick: _cache[0] || (_cache[0] = $event => (showBalance.value = !showBalance.value))
              }, null, 8, ["src"]), [
                [_directive_audio]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "menu-action-btn",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'profile' })))
              }, [
                _createVNode(_component_van_image, {
                  class: "action-btn-icon",
                  src: require('@/assets/img/common/menu/profile.png')
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('menu.account')), 1)
              ])), [
                [_directive_audio]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "menu-action-btn",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.$router.push({ name: 'recharge' })))
              }, [
                _createVNode(_component_van_image, {
                  class: "action-btn-icon",
                  src: require('@/assets/img/common/menu/deposit.png')
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('common.deposit')), 1)
              ])), [
                [_directive_audio]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "menu-action-btn",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.$router.push({ name: 'withdraw' })))
              }, [
                _createVNode(_component_van_image, {
                  class: "action-btn-icon",
                  src: require('@/assets/img/common/menu/withdraw.png')
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('common.withdraw')), 1)
              ])), [
                [_directive_audio]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList, (item) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(`menu-item flex ${_ctx.$route.name === item.pathName ? 'active' : 'inactive'}`),
                  key: item.code,
                  onClick: $event => (clickMenu(item))
                }, [
                  (item.code === 'inbox' && _unref(inboxUnread))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(inboxUnread)), 1))
                    : (item.code === 'signUpBonus' && _unref(loginBonusRewardNum))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(loginBonusRewardNum)), 1))
                      : (item.code === 'task' && _unref(taskRewardNum))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(taskRewardNum)), 1))
                        : _createCommentVNode("", true),
                  _createVNode(_component_van_image, {
                    class: "menu-icon",
                    fit: "contain",
                    src: require(`@/assets/img/common/menu/${item.code}.png`)
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`menu.${item.code}`)), 1)
                ], 10, _hoisted_15)), [
                  [_directive_audio]
                ])
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('socialMedia.follow')), 1),
                _createElementVNode("div", _hoisted_24, [
                  (_unref(followUs).follow_facebook)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 0,
                        class: "social-media-icon",
                        name: "facebook",
                        onClick: _cache[4] || (_cache[4] = $event => (_unref(openBrowser)(_unref(followUs).follow_facebook)))
                      }, null, 512)), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true),
                  (_unref(followUs).follow_telegram)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 1,
                        class: "social-media-icon",
                        name: "telegram",
                        onClick: _cache[5] || (_cache[5] = $event => (_unref(openBrowser)(_unref(followUs).follow_telegram)))
                      }, null, 512)), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true),
                  (_unref(followUs).follow_twitter)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 2,
                        class: "social-media-icon",
                        name: "x-twitter",
                        onClick: _cache[6] || (_cache[6] = $event => (_unref(openBrowser)(_unref(followUs).follow_twitter)))
                      }, null, 512)), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true),
                  (_unref(followUs).follow_tiktok)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 3,
                        class: "social-media-icon",
                        name: "tiktok",
                        onClick: _cache[7] || (_cache[7] = $event => (_unref(openBrowser)(_unref(followUs).follow_tiktok)))
                      }, null, 512)), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true),
                  (_unref(followUs).follow_youtube)
                    ? _withDirectives((_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 4,
                        class: "social-media-icon",
                        name: "youtube",
                        onClick: _cache[8] || (_cache[8] = $event => (_unref(openBrowser)(_unref(followUs).follow_youtube)))
                      }, null, 512)), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              (_unref(showAppDownload))
                ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                    key: 0,
                    class: "download-btn",
                    fit: "contain",
                    src: require(`@/assets/img/common/google-download.webp`),
                    onClick: _cache[9] || (_cache[9] = $event => (_unref(openBrowser)(_unref(downloadUrl))))
                  }, null, 8, ["src"])), [
                    [_directive_audio]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "logout-btn flex justify-center",
                onClick: doLogout
              }, [
                _createVNode(_component_SvgIcon, {
                  class: "logout-btn-icon",
                  name: "logout"
                }),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.logout')), 1)
              ])), [
                [_directive_audio]
              ]),
              _createElementVNode("div", {
                class: "app-version",
                onClick: reloadApp
              }, "V" + _toDisplayString(h5Version.value) + _toDisplayString(_unref(version) ? ` (${_unref(version)})` : ''), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

}